import React, { useState, useEffect } from 'react';

const SplashScreen = ({ onComplete }) => {
    const [isVisible, setIsVisible] = useState(true);
    const [isFading, setIsFading] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);

        const fadeTimer = setTimeout(() => {
            setIsFading(true);
        }, 6200); 

        const hideTimer = setTimeout(() => {
            setIsVisible(false);
            if (onComplete) {
                onComplete();
            }
        }, 6500);

        return () => {
            window.removeEventListener('resize', handleResize);
            clearTimeout(fadeTimer);
            clearTimeout(hideTimer);
        };
    }, [onComplete]);

    if (!isVisible) return null;

    return (
        <div 
            className={`fixed inset-0 z-[9999] flex items-center justify-center bg-white transition-opacity duration-300 ${
                isFading ? 'opacity-0' : 'opacity-100'
            }`}
        >
            <div className="flex justify-center items-center p-4 w-full h-full sm:p-8">
                <img
                    src={isMobile ? '/videos/splash-mobile.gif' : '/videos/splash-desktop.gif'}
                    alt="Cargando..."
                    className="object-contain w-full h-full max-w-[90%] max-h-[90%] sm:max-w-[80%] sm:max-h-[80%] md:max-w-[70%] md:max-h-[70%] lg:max-w-[60%] lg:max-h-[60%]"
                />
            </div>
        </div>
    );
};

export default SplashScreen;
